import React from "react"
import { createRoot } from "react-dom/client"
import {
  App as AntdApp,
  Button,
  ConfigProvider,
  message,
  Result,
  Spin,
} from "antd"
import zhCN from "antd/locale/zh_CN"
import { Navigate, RouterProvider, createBrowserRouter } from "react-router"
import { ROUTER } from "~/common/router"
import {
  emitUnauthorized,
  subscribeUnauthorized,
} from "~/common/auth/authEvents"
import { configureRequestHandlers } from "~/common/request"
import { LoginModal } from "~/components/LoginModal"
import { useSessionStore } from "~/store/session"
import { StaffLayout } from "~/layouts/StaffLayout"
import { STAFF_PAGES } from "~/pages/Staff/routes"
import "antd/dist/reset.css"
import "./Staff.css"

configureRequestHandlers({
  alwaysHandleUnauthorized: true,
  onError: (error) => {
    void message.error(error.message)
  },
  onUnauthorized: () => emitUnauthorized(),
})

const router = createBrowserRouter([
  {
    path: ROUTER.STAFF,
    element: <StaffLayout />,
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={ROUTER.STAFF_GIFT}
            replace
          />
        ),
      },
      ...STAFF_PAGES.map(({ path, element }) => ({ path, element })),
    ],
  },
  {
    path: "*",
    element: (
      <Navigate
        to={ROUTER.STAFF}
        replace
      />
    ),
  },
])

const root = document.getElementById("root")

if (!root) {
  throw new Error("Root element #root not found")
}

const StaffApp = () => {
  const initialized = useSessionStore((state) => state.initialized)
  const user = useSessionStore((state) => state.user)
  const init = useSessionStore((state) => state.init)
  const openLoginModal = useSessionStore((state) => state.openLoginModal)

  React.useEffect(() => {
    const unsubscribe = subscribeUnauthorized(() => {
      useSessionStore.getState().clear()
      useSessionStore.getState().openLoginModal()
    })
    void init()
    return unsubscribe
  }, [init])

  React.useEffect(() => {
    if (initialized && !user) openLoginModal()
  }, [initialized, user, openLoginModal])

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{ cssVar: { key: "staff" } }}
    >
      <AntdApp>
        {!initialized ? (
          <Spin
            fullscreen
            tip="正在检查登录状态..."
          />
        ) : user ? (
          <RouterProvider router={router} />
        ) : (
          <Result
            status="403"
            title="请先登录 Staff 后台"
            subTitle="登录后可继续访问当前页面"
            extra={
              <Button
                type="primary"
                onClick={openLoginModal}
              >
                登录
              </Button>
            }
          />
        )}
        <LoginModal />
      </AntdApp>
    </ConfigProvider>
  )
}

createRoot(root).render(
  <React.StrictMode>
    <StaffApp />
  </React.StrictMode>,
)
